import { PermissionResourceType, PermissionType } from "../../../models";
import { useEffect, useMemo, useState } from "react";

import { usePermissionCheck } from "../../../lib/permission/cedar/hooks/usePermissionCheck";
import { useQuery } from "react-query";

export type PermissionRestrictedControlProps = {
    resourceId: string;
    resourceType: PermissionResourceType;
    requiredPermission: PermissionType | undefined;
    permissionOverridden?: boolean;
    children: (disabled: boolean) => JSX.Element;
};

export const PermissionRestrictedControl = (props: PermissionRestrictedControlProps) => {
    const { resourceId, resourceType, requiredPermission, permissionOverridden, children } = props;
    const { checkPermission, isReady } = usePermissionCheck();

    const shouldCheckPermission = !!requiredPermission && !permissionOverridden;

    const { data: isPermissionGranted } = useQuery<boolean>({
        queryKey: ["isPermissionGranted", resourceId, resourceType, requiredPermission],
        queryFn: async () => {
            if (!requiredPermission) {
                return true;
            }
            return await checkPermission(resourceId, resourceType, requiredPermission);
        },
        enabled: isReady && shouldCheckPermission
    });

    const isEnabled = useMemo(() => {
        if (permissionOverridden || !requiredPermission) {
            return true;
        }
        return isPermissionGranted ?? false;
    }, [permissionOverridden, requiredPermission, isPermissionGranted]);

    return (
        // Short term hard coding state not be disabled for property level permission workaround
        children(false)
    );
};